import { z } from 'zod';
import { BookingStatus } from '../../../shared/types/booking/BookingStatus';

// Define the rate schema
const RateSchema = z.object({
    date: z.string(),
    rate: z.number(),
});

// Define the data schema
const DataSchema = z.object({
    id: z.string().uuid(),
    property_id: z.string().uuid(),
    customer_name: z.string(),
    customer_surname: z.string(),
    customer_email: z.string().email(),
    customer_phone: z.nullable(z.string()),
    customer_address: z.nullable(z.string()),
    customer_country: z.nullable(z.string()),
    customer_state: z.nullable(z.string()),
    customer_city: z.nullable(z.string()),
    customer_zip: z.nullable(z.string()),
    customer_date_of_birth: z.nullable(z.string()),
    customer_identity_number: z.nullable(z.string()),
    invoice_number: z.string(),
    invoice_date: z.nullable(z.string()),
    status: z.enum(BookingStatus.map(s => s.value) as [string, ...string[]]),
    mark: z.nullable(z.string()),
    payment_type: z.nullable(z.string()).optional(),
    room_type_id: z.string().uuid(),
    room_id: z.nullable(z.string().uuid()),
    rate_plan_id: z.string().uuid(),
    rates: z.array(RateSchema),
    total_rate: z.string(),
    checkin_date: z.string(),
    checkout_date: z.string(),
    adults: z.coerce.string(),
    children: z.coerce.string(),
    total_guests: z.number().min(0),
    public_note: z.nullable(z.string()),
    private_note: z.nullable(z.string()),
    source: z.string(),
});

// Define the response schema
const UpdateBookingResponse = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: DataSchema,
});

export { UpdateBookingResponse };
export type UpdateBookingResponseType = z.infer<typeof UpdateBookingResponse>;